











































    import AbpBase from "@/lib/abpbase"
    import {Component, Prop} from "vue-property-decorator"
    import {QueryCreateSysDic, QueryEditSysDic, QuerySysDic} from "@/api/material"

    @Component({
        components: {}
    })
    export default class AddOrEditMaterialClass extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean
        @Prop({type: Object, default: {}}) data: any
        form = {
            code: '',
            parentId:null,
            typeName: '',
            status: true,
            dataType: 2
        }
        types = []
		created(){
            this.getSelects()
            if (this.data.mode === 'add') {

            } else if (this.data.mode === 'edit') {
                this.form = {
                    id:this.data.data.id,
                    code: this.data.data.code,
                    parentId: this.data.data.parentId,
                    typeName: this.data.data.typeName,
                    status: this.data.data.isActive === "启用",
                    dataType: 2
				}
                // this.form =  this.data.data
	            // this.form.status = (this.data.data.isActive === "启用")
	            // this.form.parentId =
            }
		}
        get dialogTitle() {
            return this.data.mode === 'add' ? '新增' : '编辑'
        }

        save() {
            (this.$refs.form as any).validate(async (valid: boolean) => {
                if (valid) {
                    let res
                    if (this.data.mode === 'add') {
                        res = await QueryCreateSysDic(this.form)
                    } else {
                        res = await QueryEditSysDic(this.form)
                    }
	                if (res.code === 2000) {
                        this.$emit('input', false)
                        this.$emit('save-success')
	                }
                }
            })
        }
        rules = {
            code: {required: true, message: '请输入编号', trigger: 'blur'},
            typeName: {required: true, message: '请输入类型名称', trigger: 'blur'},
            parentId: {required: true, message: '请输入类型名称',type:'number',trigger: 'blur'},
        }
        cancel() {
            (this.$refs.form as any).resetFields();
            this.$emit('input', false);
        }

        private async getSelects() {
	        let res = await QuerySysDic({
		        "dataType": 1,
                "typeName": "",
                "status": true
	        })
	        this.types = res.data
        }
    }
